import { Button, Col, Select, Row, Form } from "antd";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import EmailIcon from "../../../assets/images/vectors/EmailIcon";
import { getOemNo, hasRole } from "../../../global/hooks/getUserRole";
import { useEffect } from "react";
import dayjs from "dayjs";

const isDealerListAccount = () => hasRole(7, 8);

export const InvoiceFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setShowEmailModal,
  setShowModal,
  selectedRowKeys,
  setFilter,
  params,
}) => {
  const [form] = Form.useForm();

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;
  const dealerOptionsUrl = isDealerListAccount()
    ? null
    : filter?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${filter?.OemNo}/dealers/`
      : !hasRole(1, 2, 3) && getOemNo()
        ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${getOemNo()}/dealers/`
        : null;
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  // const { role_value } = userData;
  const role_value = userData?.role_value;
  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);
  const {
    data: dealerOptions,
    loading: dealerOptionsLoading,
    error: dealerOptionsError,
  } = useGet(dealerOptionsUrl);

  const handleFormChange = (changedValues) => {
    if ("PaymentTime" in changedValues) {
      setFilter((prev) => ({
        ...prev,
        PaymentTime: changedValues.PaymentTime,
      }));
    }
  };

  useEffect(() => {
    const t = params?.get("PaymentTime");
    if (t) form.setFieldsValue({ PaymentTime: dayjs.unix(Number(t)) });
  }, [params]);

  const modifiedDealer = getModifiedResponse(dealerOptions, null);
  const modifiedOems = getModifiedResponse(optionsData, "oems");

  const onSearch = (value) => {
    console.log("search:", value);
  };

  return (
    <Form form={form} className="mb-4" onValuesChange={handleFormChange}>
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="PaymentTime"
              placeholder="Payment Time"
              format="YYYY-MM-DD HH:mm"
              showTime={{ format: "HH:mm" }}
            />
          </Col>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="InvoiceNo"
              placeholder="No"
              value={filter.CustomerNo}
              onChange={handleFilterChange}
            />
          </Col> */}
          {!isDealerListAccount() ? (
            <>
              {hasRole(1, 2, 3) && (
                <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                  <Select
                    showSearch
                    placeholder="OEM"
                    optionFilterProp="label"
                    value={filter.OemNo || undefined}
                    onChange={(value) =>
                      setFilter({
                        ...filter,
                        OemNo: value,
                        DealerNo: undefined,
                      })
                    }
                    onSearch={onSearch}
                    options={modifiedOems}
                    style={{ width: "100%" }}
                  />
                </Col>
              )}

              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                <Select
                  showSearch
                  placeholder="Dealer"
                  optionFilterProp="label"
                  value={filter.DealerNo || undefined}
                  onChange={(value) =>
                    setFilter({ ...filter, DealerNo: value })
                  }
                  onSearch={onSearch}
                  options={modifiedDealer}
                  style={{ width: "100%" }}
                  disabled={
                    hasRole(4, 5, 6)
                      ? false
                      : filter.OemNo === undefined ||
                        filter.OemNo === null ||
                        filter.OemNo === ""
                  }
                  title="Please select an OEM first"
                />
              </Col>
            </>
          ) : null}

          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              placeholder="Payment Mode"
              value={
                filter.PaymentMode === "" || filter.PaymentMode == null
                  ? undefined
                  : Number(filter.PaymentMode)
              }
              onChange={(value) => setFilter({ ...filter, PaymentMode: value })}
              allowClear
              options={[
                { value: 1, label: "Manual" },
                { value: 0, label: "Card" },
              ]}
              style={{ width: "100%" }}
            />
          </Col>

          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="EndDate"
              placeholder="End Date"
              format="YYYY-MM-DD hh:mm A"
              value={filter.EndDate}
              onChange={(value) => setFilter({ ...filter, EndDate: value })}
              // onChange={(value) => console.log(value)}
            />
          </Col> */}
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Paid"
              optionFilterProp="Paid"
              value={filter.Paid || undefined}
              onChange={(value) => setFilter({ ...filter, Paid: value })}
              onSearch={onSearch}
              options={[
                {
                  value: 1,
                  label: "Yes",
                },
                {
                  value: 0,
                  label: "No",
                },
              ]}
              style={{ width: "100%" }}
            />
          </Col> */}
        </Row>
      </div>

      <div className="flex justify-between my-4 overflow-x-auto !items-center">
        <div className="flex items-center">
          <Button
            type="primary"
            className="mr-2 w-[104px] h-[32px] font-medium"
            onClick={handleFilter}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            Apply
          </Button>
          <Button
            className="reset-button"
            onClick={() => {
              form.resetFields();
              handleReset();
            }}
          >
            <HiArrowPath className="!text-[14px] font-medium" />
            Reset
          </Button>
          {[1, 2].includes(role_value) && (
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[32px] font-medium"
              onClick={() => setShowEmailModal(true)}
              disabled={selectedRowKeys?.length === 0 ? true : false}
            >
              <EmailIcon color="white" size={16} />
              Email
            </Button>
          )}
        </div>
      </div>
    </Form>
  );
};
